import React from 'react';
import Box from '@mui/material/Box';
import PatternAnimalSymbols, { animalAccessibleLabel, hasAnimalSymbol } from './PatternAnimalSymbols';
import { usePatternSize } from './PatternSizeContext';

function tokenGlyph(token) {
  return token?.fallback_glyph || token?.label || '?';
}

export default function PatternToken({ token, size = 'normal' }) {
  const questionSize = usePatternSize();
  const compact = size === 'compact';
  if (!token || token.kind === 'empty') {
    return (
      <Box
        aria-label={token?.label || 'eksik parça'}
        data-pattern-size-item={questionSize.enabled || undefined}
        sx={{
          width: questionSize.enabled ? `${questionSize.slot}px` : size === 'small' ? 38 : compact ? { xs: 36, sm: 60, md: 72 } : { xs: 48, sm: 60, md: 72 },
          height: questionSize.enabled ? `${questionSize.slot}px` : size === 'small' ? 38 : compact ? { xs: 36, sm: 60, md: 72 } : { xs: 48, sm: 60, md: 72 },
          boxSizing: questionSize.enabled ? 'border-box' : undefined,
          flexShrink: questionSize.enabled ? 0 : undefined,
          border: '3px dashed #a78bfa',
          borderRadius: 2.5,
          bgcolor: 'rgba(245,243,255,0.76)',
          display: 'grid',
          placeItems: 'center',
          color: '#7c3aed',
          fontSize: questionSize.enabled ? `${22 * questionSize.scale}px` : size === 'small' ? 22 : compact ? { xs: 23, sm: 34, md: 40 } : { xs: 28, sm: 34, md: 40 },
          fontWeight: 900,
        }}
      >
        ?
      </Box>
    );
  }

  const glyph = tokenGlyph(token);
  const hasAnimal = hasAnimalSymbol(glyph);

  return (
    <Box
      component="span"
      role="img"
      aria-label={hasAnimal ? animalAccessibleLabel(token.label || glyph) : token.label || 'desen parçası'}
      sx={{
        minWidth: size === 'small' ? 34 : compact ? { xs: 36, sm: 62, md: 70 } : { xs: 52, sm: 62, md: 70 },
        minHeight: size === 'small' ? 34 : compact ? { xs: 36, sm: 62, md: 70 } : { xs: 52, sm: 62, md: 70 },
        display: 'inline-grid',
        placeItems: 'center',
        bgcolor: hasAnimal ? '#fff' : 'transparent',
        border: hasAnimal ? '2px solid #ddd6fe' : 'none',
        borderRadius: hasAnimal ? '50%' : 0,
        fontFamily: '"Segoe UI Symbol", "Apple Symbols", sans-serif',
        fontSize: size === 'small'
          ? 27
          : compact
          ? (hasAnimal ? { xs: 26, sm: 42, md: 48 } : { xs: 25, sm: 45, md: 52 })
          : hasAnimal
          ? { xs: 34, sm: 42, md: 48 }
          : { xs: 36, sm: 45, md: 52 },
        lineHeight: 1,
        filter: token.kind === 'asset' ? 'drop-shadow(0 2px 2px rgba(15,23,42,0.12))' : 'none',
      }}
    >
      {hasAnimal ? <PatternAnimalSymbols text={glyph} decorative /> : glyph}
    </Box>
  );
}

export function QuantityToken({ value }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 0.25, maxWidth: 180 }}>
      {Array.from({ length: Number(value?.count || 0) }, (_, index) => (
        <PatternToken key={index} token={value?.token} size="small" />
      ))}
    </Box>
  );
}
